import { downloadCsv, csvDateStamp } from '../../utils/csvExport';
import { SESSION_EXPORT_COLUMNS, ALL_SESSIONS_COLUMNS, flattenSessionRows, slug } from './sessionExportData';

/** Télécharge le CSV d'une séance (résultat de l'API : { eventName, session, rows }). */
export const downloadSessionCsv = ({ eventName, session, rows }) =>
  downloadCsv(`participants_${slug(eventName || 'event')}_${slug(session.nom)}_${csvDateStamp()}`, SESSION_EXPORT_COLUMNS, rows);

/**
 * Télécharge un seul CSV pour plusieurs séances (résultat de l'API : { eventName, sessions: [{ session, rows }] }).
 * `label` nomme le fichier (« toutes_les_seances » par défaut, ou une journée). Ne télécharge rien
 * sans ligne : retourne alors 0.
 */
export const downloadAllSessionsCsv = ({ eventName, sessions }, label = 'toutes_les_seances') => {
  const rows = flattenSessionRows(sessions);
  if (rows.length === 0) return 0;
  downloadCsv(`participants_${slug(eventName || 'event')}_${slug(label)}_${csvDateStamp()}`, ALL_SESSIONS_COLUMNS, rows);
  return rows.length;
};
